import { Routes } from '@angular/router';
import { TournamentHomeComponent } from './tournament-home/tournament-home.component';
import { TournamentResolver } from './tournament.resolver';
import { ROUTE_TOURNAMENT_STAGES_ROOT } from '@config/routing-map';


export const ROUTES: Routes = [
  {
    path: '',
    component: TournamentHomeComponent,
    resolve: {
      data: TournamentResolver
    },
    children: [
      {
        path: ROUTE_TOURNAMENT_STAGES_ROOT,
        loadChildren: () => import('./tournament-stages/tournament-stages.module').then(m => m.TournamentStagesModule)
      }
    ]
  },
];

